module.exports = __webpack_public_path__ + "media/images/www/bbb-e27308ae26c6bed3ebbdde07f089d7e7.svg";